import { Reducer } from 'redux'
import {
  ProductDimensionActions,
  Actions,
} from '../actions/productDimensionAction'
import { IProductDimensionState } from '../interfaces'

const initialState: IProductDimensionState = {
  loading: false,
  foutmelding: undefined,
  productDimensions: [],
  productDimension: null,
}

export const productDimensionReducer: Reducer<
  IProductDimensionState,
  ProductDimensionActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetProductDimensionsRequest:
      return {
        ...state,
        loading: true,
        productDimensions: [],
        foutmelding: null,
      }
    case Actions.GetProductDimensionsResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        productDimensions: action.success ? action.payload : [],
      }
    case Actions.GetProductDimensionRequest:
      return {
        ...state,
        loading: true,
        productDimension: null,
        foutmelding: null,
      }
    case Actions.GetProductDimensionResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        productDimension: action.success ? action.payload : null,
      }
    case Actions.PostProductDimensionRequest:
      return {
        ...state,
        loading: true,
        productDimension: null,
        foutmelding: null,
      }
    case Actions.PostProductDimensionResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
      }
    case Actions.UpdateProductDimensionRequest:
      return {
        ...state,
        loading: true,
        productDimension: null,
        foutmelding: null,
      }
    case Actions.UpdateProductDimensionResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
      }
    case Actions.DeleteProductDimensionRequest:
      return {
        ...state,
        loading: true,
        foutmelding: null,
      }
    case Actions.DeleteProductDimensionResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
      }
    case Actions.ClearError:
      return {
        ...state,
        foutmelding: null,
      }
    default:
      return { ...state }
  }
}
